<ng-container *ngIf="iconName; else contentTemplate">
  <svg>
    <use [attr.href]="'assets/ae-icons/icons.svg#' + iconName" [attr.xlink:href]="'assets/ae-icons/icons.svg#' + iconName"></use>
  </svg>
</ng-container>
<ng-template #contentTemplate>
  <ng-content></ng-content>
</ng-template>
